import ServerBaseError from './ServerBaseError';

export default class ServerInternalError extends ServerBaseError {
  constructor(message = 'Server error', showErrorPage = false) {
    super(message, showErrorPage);
  }
}
